exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.has-error[data-v-bdac212c] {\n    border-color: #d9534f;\n}\n", ""]);

// exports
